import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const LocationTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "92a07324-ac3c-464a-bd52-b1cb674d9dea";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="locationcode" caption="Location"  />
                <Column dataField="classcode" caption="Class"  />
                <Column dataField="subcategory" caption="Sub Class"  />
                <Column dataField="warehouseId" caption="Warehouse"/>
                <Column dataField="warehouseName" caption="Name" />
                <Column dataField="description" caption="Description" />
                <Column dataField="priority" caption="Priority"  />
                <Column dataField="height" caption="Height" />
                <Column dataField="width" caption="Width"  />
                <Column dataField="depth" caption="Depth" />

    <Column dataField="creationdatetime" caption="Creation Date Time" dataType="date" visible={false} />
    <Column dataField="creationuserid" caption="Creation User ID" visible={false} />
    <Column dataField="lastupdatedatetime" caption="Last Update Date Time" dataType="date" visible={false} />
    <Column dataField="lastupdateuserid" caption="Last Update User ID" visible={false} />
    <Column dataField="module" caption="Module" visible={false} />
    <Column dataField="companyid" caption="Company ID" visible={false} />
    <Column dataField="recordtype" caption="Record Type" visible={false} />
    <Column dataField="rProfile" caption="Profile" visible={false} />
    
    <Column dataField="status" caption="Status" visible={false} />
    <Column dataField="locationtype" caption="Location Type" visible={false} />
    <Column dataField="dimensions" caption="Dimensions" visible={false} />

    
    <Column dataField="capacityunits" caption="Capacity Units" visible={false} />
    <Column dataField="capacitylimitflag" caption="Capacity Limit Flag" visible={false} />
    <Column dataField="capacitypieces" caption="Capacity Pieces" visible={false} />
    <Column dataField="capacitypieceslimitflag" caption="Capacity Pieces Limit Flag" visible={false} />
    <Column dataField="capacitycontainerunits" caption="Capacity Container Units" visible={false} />
    <Column dataField="capacitycontainerlimitflag" caption="Capacity Container Limit Flag" visible={false} />
    <Column dataField="capacityshippingunits" caption="Capacity Shipping Units" visible={false} />
    <Column dataField="capacityshippingunitslimitflag" caption="Capacity Shipping Units Limit Flag" visible={false} />
    <Column dataField="capacitygrossweight" caption="Capacity Gross Weight" visible={false} />
    <Column dataField="capacitygrossweightlimitflag" caption="Capacity Gross Weight Limit Flag" visible={false} />
    <Column dataField="capacitynetweight" caption="Capacity Net Weight" visible={false} />
    <Column dataField="capacitynetweightlimitflag" caption="Capacity Net Weight Limit Flag" visible={false} />
    <Column dataField="capacityarea" caption="Capacity Area" visible={false} />
    <Column dataField="capacityarealimitflag" caption="Capacity Area Limit Flag" visible={false} />
    <Column dataField="capacityvolume" caption="Capacity Volume" visible={false} />
    <Column dataField="capacityvolumelimitflag" caption="Capacity Volume Limit Flag" visible={false} />
    <Column dataField="minimumunits" caption="Minimum Units" visible={false} />
    <Column dataField="maximumunits" caption="Maximum Units" visible={false} />

    <Column dataField="userdefinedcode1" caption="User Defined Code 1" visible={false} />
    <Column dataField="userdefinedcode2" caption="User Defined Code 2" visible={false} />
    <Column dataField="userdefinedcode3" caption="User Defined Code 3" visible={false} />
    <Column dataField="userdefinedcode4" caption="User Defined Code 4" visible={false} />
    <Column dataField="userdefinedcode5" caption="User Defined Code 5" visible={false} />
    <Column dataField="userdefinedcode6" caption="User Defined Code 6" visible={false} />
    <Column dataField="userdefinedcode7" caption="User Defined Code 7" visible={false} />
    <Column dataField="userdefinedcode8" caption="User Defined Code 8" visible={false} />
    <Column dataField="userdefinedcode9" caption="User Defined Code 9" visible={false} />
    <Column dataField="userdefinedcode10" caption="User Defined Code 10" visible={false} />
    <Column dataField="userdefinedreference1" caption="User Defined Reference 1" visible={false} />
    <Column dataField="userdefinedreference2" caption="User Defined Reference 2" visible={false} />
    <Column dataField="userdefinedreference3" caption="User Defined Reference 3" visible={false} />
    <Column dataField="userdefinedreference4" caption="User Defined Reference 4" visible={false} />
    <Column dataField="userdefinedreference5" caption="User Defined Reference 5" visible={false} />
    <Column dataField="userdefinedreference6" caption="User Defined Reference 6" visible={false} />
    <Column dataField="userdefinedreference7" caption="User Defined Reference 7" visible={false} />
    <Column dataField="userdefinedreference8" caption="User Defined Reference 8" visible={false} />
    <Column dataField="userdefinedreference9" caption="User Defined Reference 9" visible={false} />
    <Column dataField="userdefinedreference10" caption="User Defined Reference 10" visible={false} />
    <Column dataField="userdefineddate1" caption="User Defined Date 1"dataType="date" visible={false} />
    <Column dataField="userdefineddate2" caption="User Defined Date 2"dataType="date" visible={false} />
    <Column dataField="userdefineddate3" caption="User Defined Date 3"dataType="date" visible={false} />
    <Column dataField="userdefineddate4" caption="User Defined Date 4"dataType="date" visible={false} />
    <Column dataField="userdefineddate5" caption="User Defined Date 5"dataType="date" visible={false} />
    <Column dataField="userdefineddate6" caption="User Defined Date 6"dataType="date" visible={false} />
    <Column dataField="userdefineddate7" caption="User Defined Date 7"dataType="date" visible={false} />
    <Column dataField="userdefineddate8" caption="User Defined Date 8"dataType="date" visible={false} />
    <Column dataField="userdefineddate9" caption="User Defined Date 9"dataType="date" visible={false} />
    <Column dataField="userdefineddate10" caption="User Defined Date 10" dataType="date" visible={false} />
    <Column dataField="userdefinedquantity1" caption="User Defined Quantity 1" visible={false} />
    <Column dataField="userdefinedquantity2" caption="User Defined Quantity 2" visible={false} />
    <Column dataField="userdefinedquantity3" caption="User Defined Quantity 3" visible={false} />
    <Column dataField="userdefinedquantity4" caption="User Defined Quantity 4" visible={false} />
    <Column dataField="userdefinedquantity5" caption="User Defined Quantity 5" visible={false} />
    <Column dataField="userdefinedquantity6" caption="User Defined Quantity 6" visible={false} />
    <Column dataField="userdefinedquantity7" caption="User Defined Quantity 7" visible={false} />
    <Column dataField="userdefinedquantity8" caption="User Defined Quantity 8" visible={false} />
    <Column dataField="userdefinedquantity9" caption="User Defined Quantity 9" visible={false} />
    <Column dataField="userdefinedquantity10" caption="User Defined Quantity 10" visible={false} />
    <Column dataField="rWarehouse" caption="Warehouse" visible={false} />
    <Column dataField="profileguid" caption="Profile GUID" visible={false} />


                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationTabResult);